import { ShowImageDialogComponent } from './dialogs/show-image-dialog.component';
import { NotebookPresentationDialogComponent } from './dialogs/notebook-presentation-dialog/notebook-presentation-dialog.component';
import { EditNotebookDialogComponent } from './dialogs/edit-notebook-dialog.component';
import { DeleteButtonComponent } from './delete-button/delete-button.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { LayoutModule } from '@angular/cdk/layout';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldControl, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ShellComponent } from './shell/shell.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatTreeModule} from '@angular/material/tree';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {MatRadioModule} from '@angular/material/radio';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table';
import {MatSortModule} from '@angular/material/sort';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatLegacyChipsModule as MatChipsModule} from '@angular/material/legacy-chips';
import {MatSelectModule} from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';

import { NotebooksListComponent } from './notebooks-list/notebooks-list.component';
import { CreateNotebookDialogComponent } from './dialogs/create-notebook-dialog.component';
import { CreateNoteDialogComponent } from './dialogs/create-note-dialog.component';
import { EditNoteDialogComponent } from './dialogs/edit-note-dialog.component';
import { DeleteNoteDialogComponent } from './dialogs/delete-note-dialog.component';
import { DeleteNotebookDialogComponent } from './dialogs/delete-notebook-dialog.component';
import { ExportDialogComponent } from './dialogs/export-dialog.component';
import { DeferLoadDirective } from './defer-load/defer-load.directive';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ToastModule } from 'primeng/toast';
import { RippleModule } from 'primeng/ripple';
import { MessageService } from 'primeng/api';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MAT_DATE_LOCALE } from '@angular/material/core';


export function getLocale() {
  return navigator.language;
}

const components = [ShellComponent, DeleteButtonComponent, NotebooksListComponent, CreateNotebookDialogComponent,
  CreateNoteDialogComponent, EditNoteDialogComponent, DeleteNoteDialogComponent, DeleteNotebookDialogComponent, EditNotebookDialogComponent,
  ShowImageDialogComponent, NotebookPresentationDialogComponent, ExportDialogComponent, DeferLoadDirective];

const modules = [
  CommonModule,
  MatButtonModule,
  MatToolbarModule,
  MatIconModule,
  LayoutModule,
  MatSidenavModule,
  MatListModule,
  MatMenuModule,
  MatIconModule,
  MatCardModule,
  MatFormFieldModule,
  MatInputModule,
  MatSnackBarModule,
  MatProgressBarModule,
  RouterModule,
  FormsModule,
  MatAutocompleteModule,
  MatFormFieldModule,
  MatDialogModule,
  ReactiveFormsModule,
  MatTreeModule,
  MatCheckboxModule,
  MatSlideToggleModule,
  DragDropModule,
  MatRadioModule,
  MatStepperModule,
  MatTableModule,
  MatSortModule,
  MatPaginatorModule,
  MatChipsModule,
  MatSelectModule,
  MatExpansionModule,
  MatTooltipModule,
  ToastModule,
  RippleModule,
  ProgressSpinnerModule
];


@NgModule({
  declarations: [...components],
  imports: [...modules],
  exports: [
    ...components,
    ...modules,
  ],
  providers: [
    MessageService,
    { provide: MAT_DATE_LOCALE, useFactory: getLocale }

  ]
})
export class SharedModule { }
